import { render, staticRenderFns } from "./EqifyRulePersonHasLicenseType.vue?vue&type=template&id=6f540db1&scoped=true"
import script from "./EqifyRulePersonHasLicenseType.vue?vue&type=script&lang=ts"
export * from "./EqifyRulePersonHasLicenseType.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f540db1",
  null
  
)

export default component.exports